// --------------------------------- Types ------------------------------ //
// ---------------------------------------------------------------------- //

export const LOAD_IMAGES_SUBMIT = 'LOAD_IMAGES_SUBMIT';

// ---------------------------------------------------------------------- //
// ---------------------------------------------------------------------- //
